// Client data for the STISSA Technology LLP (TISSA Technology) website

export const clients = [
    { 
      name: "Weirdoughs", 
      img: "/assets/images/client/weirdoughs.png",
      height: "90px",
      maxWidth: "140px" 
    },
    { 
      name: "Grocery60", 
      img: "/assets/images/client/Grocery60.png",
      maxWidth: "190px" 
    },
    { 
      name: "KidsKart", 
      img: "/assets/images/client/Kidskartlogo.png",
      maxWidth: "190px" 
    },
    { 
      name: "Ema", 
      img: "/assets/images/client/ema-logo.png",
      maxWidth: "190px" 
    },
    // { 
    //   name: "InstaApp", 
    //   img: "/assets/images/client/InstaApp.png",
    //   maxWidth: "190px" 
    // },
    { 
      name: "MunCheese", 
      img: "/assets/images/client/MunCheese.png",
      maxWidth: "190px" 
    },
    { 
      name: "Fidelity", 
      img: "/assets/images/client/fidelity.jpg",
      height: "65px",
      maxWidth: "160px" 
    },
    { 
      name: "Exsurgo", 
      img: "/assets/images/client/exsurgo.png",
      height: "110px",
      maxWidth: "140px" 
    },
    { 
      name: "Envision", 
      img: "/assets/images/client/envision.png",
      maxWidth: "190px" 
    },
    { 
      name: "Cignity", 
      img: "/assets/images/client/cignity.png",
      height: "80px",
      maxWidth: "190px" 
    },
    { 
      name: "Cevent", 
      img: "/assets/images/client/cevent.jpg",
      height: "70px",
      maxWidth: "160px" 
    },
    { 
      name: "ViewLift", 
      img: "/assets/images/client/viewlift.png",
      height: "70px",
      maxWidth: "120px" 
    },
    { 
      name: "AXA", 
      img: "/assets/images/client/axa.png",
      height: "80px",
      maxWidth: "120px" 
    },
    { 
      name: "RANY", 
      img: "/assets/images/client/rany.png",
      height: "100px",
      maxWidth: "140px" 
    },
    { 
      name: "Bemed Supply", 
      img: "/assets/images/client/bemedsupply.png",
      maxWidth: "190px" 
    },
    { 
      name: "Elite", 
      img: "/assets/images/client/elite.png",
      maxWidth: "190px" 
    },
    { 
      name: "Nationwide", 
      img: "/assets/images/client/nationwide.png",
      maxWidth: "190px" 
    },
    { 
      name: "San Antonio", 
      img: "/assets/images/client/sunantonio.png",
      maxWidth: "190px" 
    },
    { 
      name: "Funding Logic", 
      img: "/assets/images/client/funding-logic.png",
      maxWidth: "160px" 
    },
    { 
      name: "Lifelong", 
      img: "/assets/images/client/lifelong-logo.png",
      maxWidth: "110px" 
    },
    { 
      name: "Softnice", 
      img: "/assets/images/client/softnice.png",
      maxWidth: "190px" 
    },
    { 
      name: "Nexgen", 
      img: "/assets/images/client/nexgen.png",
      height: "75px",
      maxWidth: "140px" 
    }
  ];
  
  export default clients;